export const experiences = [
    {
        year: "2023",
        title: "System developer Stacc",
        description: "Worked as a system developer for Stacc. My tasks involved developing a web portal for a customer in the finance sector.",
    },
    {
        year: "2023",
        title: "Masters degree in computer science",
        description: "Finished a master's degree from NTNU in Trondheim, Norway. The master's degree is in computer science with a specialization in artificial intelligence.",
    },
    {
        year: "2022",
        title: "Summer intern for Bredvid",
        description: "Worked as an IT consultant for Bredvid. My tasks involved creating a web portal with stacks such as React, Kotlin, and Azure.",
    },
    {
        year: "2021",
        title: "Bachelors degree in computer science",
        description: "Finished a bachelor's degree from NTNU in Ålesund, Norway.",
    },
    {
        year: "2019-2021",
        title: "Programmer at Multilux",
        description: "I worked as a programmer for Multilux on their CitySight-project. I was involved in developing a smart-city solution where the main goal of the project was to make it easier for municipalities to control street lights and save energy through the use of sensors.",
    },
    {
        year: "2017",
        title: "Military policy at the Norwegian army",
        description: "Worked as a military police soldier at Haakonsvern, Bergen.",
    },
    {
        year: "2012-2016",
        title: "Retail worker at Spar Kaldnes",
        description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Praesentium sint ipsa provident cupiditate, molestiae debitis consequuntur aspernatur voluptatum aperiam perferendis.",
    },
];
